import { components } from 'react-select';
import { Avatar, Box, Flex } from '@chakra-ui/react';
import { CalendarNotConnectedTooltip } from './CalendarNotConnectedTooltip';

export const SchAiInterviewerMultiValueLabel = ({
  children,
  data,
  ...props
}: any) => {
  const isCalendarDisconnected = data?.calendar_available === false;

  return (
    <components.MultiValueLabel {...props}>
      <Flex alignItems="center" gap="4px">
        {isCalendarDisconnected && (
          <CalendarNotConnectedTooltip onClick={(e) => e.stopPropagation()} />
        )}
        <Avatar
          className="avatar-xs"
          name={data?.name}
          width="20px"
          height="20px"
          src={data?.avatar}
        />
        <Box as="span" display="inline-block" ml="sm">
          {children}
        </Box>
      </Flex>
    </components.MultiValueLabel>
  );
};
